var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.328125,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 26C16.3281 24.8954 17.2236 24 18.3281 24H46.3281C47.4327 24 48.3281 24.8954 48.3281 26V52H18.3281C17.2236 52 16.3281 51.1046 16.3281 50V26Z",
    fill: "url(#paint0_linear_25933_18979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3281 46H20.3281V52H64.3281V46Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4056 32H50.3281V46H64.3281V40.9031C64.3281 39.9948 64.019 39.1136 63.4516 38.4043L59.5291 33.5012C58.77 32.5524 57.6208 32 56.4056 32Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9424 39.2226L58.1845 36.8193C57.8079 36.3044 57.2082 36 56.5702 36H56.5567H54.3281V42H60.3281V40.4034C60.3281 39.9788 60.193 39.5653 59.9424 39.2226Z",
    fill: "#F7F7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3281 53C20.3281 55.7614 22.5667 58 25.3281 58C28.0895 58 30.3281 55.7614 30.3281 53C30.3281 50.2386 28.0895 48 25.3281 48C22.5667 48 20.3281 50.2386 20.3281 53Z",
    fill: "#F7F7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3281 56C23.6713 56 22.3281 54.6569 22.3281 53C22.3281 51.3431 23.6713 50 25.3281 50C26.985 50 28.3281 51.3431 28.3281 53C28.3281 54.6569 26.985 56 25.3281 56ZM25.3281 58C22.5667 58 20.3281 55.7614 20.3281 53C20.3281 50.2386 22.5667 48 25.3281 48C28.0895 48 30.3281 50.2386 30.3281 53C30.3281 55.7614 28.0895 58 25.3281 58Z",
    fill: "#8E8CEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3281 53C50.3281 55.7614 52.5667 58 55.3281 58C58.0895 58 60.3281 55.7614 60.3281 53C60.3281 50.2386 58.0895 48 55.3281 48C52.5667 48 50.3281 50.2386 50.3281 53Z",
    fill: "#F7F7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3281 56C53.6713 56 52.3281 54.6569 52.3281 53C52.3281 51.3431 53.6713 50 55.3281 50C56.985 50 58.3281 51.3431 58.3281 53C58.3281 54.6569 56.985 56 55.3281 56ZM55.3281 58C52.5667 58 50.3281 55.7614 50.3281 53C50.3281 50.2386 52.5667 48 55.3281 48C58.0895 48 60.3281 50.2386 60.3281 53C60.3281 55.7614 58.0895 58 55.3281 58Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25933_18979",
    x1: 43.3281,
    y1: 18,
    x2: 19.3789,
    y2: 47.7858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608323,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608423,
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8CEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransport);
export default __webpack_public_path__ + "static/media/icon-transport.ace32e6ad49682634dd321e9160b695a.svg";
export { ForwardRef as ReactComponent };